module.exports = __webpack_public_path__ + "static/media/ELS30M67.e49968ae.png";